import { render, staticRenderFns } from "./MainCategoryList.vue?vue&type=template&id=0fab32ab&"
import script from "./MainCategoryList.vue?vue&type=script&lang=js&"
export * from "./MainCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports